import { type FC } from 'react';

import { RouterProvider } from 'react-router-dom';

import { makeRouter } from '../router';

const router = makeRouter();

export const AppRouter: FC = () => {
  return <RouterProvider router={router} />;
};
